<script>
import Base from '@backend/Base.vue';
import Gen from '@helper/Gen';

export default {
  name: "BoProfile",
  extends: Base,
  data(){
    return {
      Name:"BoProfile",
      mrLevel: {},
      row: {},
      mrValidation: {
        employeename: "required"
      }
    }
  },
  mounted(){
    this.$set(this.$root, 'page', this)
    this.refreshData(()=>{
      setTimeout(()=>{this.$set(this.row, 'type', 'update')},500)
    })        

    this.setRow()
  },
  methods:{
    successFormCallback(resp){
      Gen.info(resp.message, "success", 3000)
      if(!resp.isSame){
        setTimeout(() => { 
          this.page.logout()      
         }, 1000)
      }
      this.refreshUser()
    },
    setRow(){
      const newRow = {
        cwid: this.user.cwid,
        employeename: this.user.employeename,
        email: this.user.email,
        password: ''
      }

      this.$set(this, 'row', newRow)      
    },
    reload(){
      setTimeout(() => { 
        this.page.logout()
       }, 2800)
    }
  },
  watch:{
    '$route.query'(v){
      this.refreshData()
    }
  }
}
</script>

<template>
  <div class="container-fluid">
    <h3 class="mt-4">Profile</h3>

    <!-- ======================================================================== 
      FORM CRUD
    ============================================================================= -->
    <div class="card card-flat mt-4">
      <VForm @resp="submitForm" method="post">
        <!-- <div class="card-heading">
          <h2 class="card-title">{{PageName}}</h2>
        </div> -->
        <div class="card-body">
          <div class="info"></div>
          <div class="row">
            <div class="col-sm-6">
              <BoField name="employeename" v-model="row.employeename" mandatory></BoField>
              <BoField label="CWID" v-model="row.cwid" keyFilter="usernameKey" :disabled="true">
                <span slot="help" class="help-block">
                  <small>CWID for login to Backoffice page</small>
                </span>
              </BoField>
            </div>

            <div class="col-sm-6">
              <BoField label="Email" v-model="row.email" :attr="{type:'email'}"></BoField>              
              <BoField name="old_password" v-model="row.old_password" :attr="{type:'password'}"></BoField>              
              <BoField label="New Password" v-model="row.password" :attr="{type:'password', placeholder:'New Password'}"></BoField>              
            </div>

            <div class="col-sm-12 mt-4 mb-4">
              <div class="text-right">
                <router-link :to="{ name: 'Dashboard' }">
                  <button type="button" class="btn btn-default mr5">Cancel</button>
                </router-link>
                <button type="submit" class="fcbtn btn btn-info btn-outline btn-1e btn-loading">Submit form <i class="icon-arrow-right14 position-right"></i></button>
              </div>
            </div>
          </div>
        </div>
      </VForm>
    </div>
  </div>
</template>
